import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useTranslation } from '@tyro/i18n';
import { NestedFilesIcon } from '@tyro/icons';
import type { ReturnTypeFromUseDocumentationPages } from '../../api/pages';
import { PageKindIcon } from '../page-kind-icon';

interface SubPageCardProps {
  child: ReturnTypeFromUseDocumentationPages;
  grandchildCount: number;
  onSelect: () => void;
}

export function SubPageCard({
  child,
  grandchildCount,
  onSelect,
}: SubPageCardProps) {
  const { t } = useTranslation(['documentation']);
  const hasChildren = grandchildCount > 0;
  return (
    <Card
      sx={{
        height: '100%',
        transition: 'box-shadow 150ms ease, background-color 150ms ease',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <CardActionArea onClick={onSelect} sx={{ height: '100%', p: 1.5 }}>
        <Stack direction="row" gap={1.25} alignItems="flex-start">
          {hasChildren ? (
            <NestedFilesIcon
              sx={{
                fontSize: 18,
                color: 'text.disabled',
                flexShrink: 0,
                mt: 0.25,
              }}
            />
          ) : (
            <PageKindIcon
              entityType={child.entityType}
              withTooltip
              sx={{ color: 'text.disabled', mt: 0.25 }}
            />
          )}
          <Stack gap={0.25} sx={{ minWidth: 0, flex: 1 }}>
            <Typography
              variant="subtitle2"
              noWrap
              sx={{ fontWeight: 600, color: 'text.primary' }}
            >
              {child.title}
            </Typography>
            {hasChildren && (
              <Typography variant="caption" color="text.disabled">
                {t('documentation:reader.subPagesCount', {
                  count: grandchildCount,
                })}
              </Typography>
            )}
          </Stack>
        </Stack>
      </CardActionArea>
    </Card>
  );
}
